import { PathInfo, BattleUnit, Hex, FactionType, BattleStatus } from "@/core/types/battle.types";
import { BattleStore } from "@/store/useBattleStore";

export const initialPathInfo: PathInfo = {
  path: [],
  lastStep: null,
  cost: 0,
};

export const getInitialState = () => ({
    units: new Map<string, BattleUnit>(),
    battleMap: new Map<string, Hex>(),
    selectedUnitId: null,
    selectedHexId: null,
    selectedPath: initialPathInfo,
    inspectedUnitId: null,
    round: 1,
    activeFaction: FactionType.Player,
    reachableHexes: [],
    reachableHexesWithCost: new Map<string, number>(),
    currentPathPoints: [],
    turnQueue: [],
    finishedPools: [],
    selectedSkillId: null,
    targetHexes: [],
    zocHexes: new Set<string>(),
    status: BattleStatus.Preparing,
});

export class BattleMut {
    static updateHex(state: BattleStore, hexId: string, patch: Partial<Hex>) {
        const hex = state.battleMap.get(hexId);
        if (hex) state.battleMap.set(hexId, { ...hex, ...patch });
    }

    static updateUnit(state: BattleStore, id: string, patch: Partial<BattleUnit>) {
        const u = state.units.get(id);
        if (u) state.units.set(id, { ...u, ...patch });
    }

    static resetSelectedPath(state: BattleStore) {
        state.selectedPath = initialPathInfo;
    }

    static setReachableHexes(
        state: BattleStore, 
        hexes: string[], 
        costMap: Map<string, number>
    ) {
        state.reachableHexes = hexes;
        state.reachableHexesWithCost = costMap;
    }
}